export const ImagesMixin ={
    computed:{
        Images() {
            return this.data.images
        }
    }
}
